import React from 'react'
import Icon from '../icon'
import { ButtonIcon, Container, Link } from './styles'

type Props = {
  'data-qa'?: string
  urls: BreadCrumbsProps[]
}

const BreadcrumbsAlt: React.FC<Props> = (props: Props) => {
  return (
    <>
      <Container>
        <ol data-qa={props['data-qa']}>
          {props.urls.map((breadcrumb, index) => {
            return (
              <>
                <li key={index}>
                  {breadcrumb.icon && (
                    <ButtonIcon
                      href={breadcrumb.url}
                      data-qa={
                        props['data-qa'] && `${props['data-qa']}-button-icon`
                      }
                    >
                      <Icon
                        name={breadcrumb.icon}
                        size={'20'}
                        color={'neutralColorLowLight'}
                      />
                    </ButtonIcon>
                  )}

                  {breadcrumb.text && (
                    <Link
                      href={breadcrumb.url}
                      data-qa={props['data-qa'] && `${props['data-qa']}-link`}
                    >
                      {breadcrumb.text}
                    </Link>
                  )}

                  {breadcrumb.divider ? (
                    <>{props.urls[index + 1] && <>{breadcrumb.divider}</>}</>
                  ) : (
                    <>
                      {index === 0 && <DividerIcon />}

                      {!(index === 0) && props.urls[index + 1] && (
                        <DividerRotateIcon
                          data-qa={
                            props['data-qa'] && `${props['data-qa']}-divider`
                          }
                        />
                      )}
                    </>
                  )}
                </li>
              </>
            )
          })}
        </ol>
      </Container>
    </>
  )
}

BreadcrumbsAlt.defaultProps = {
  urls: [
    { icon: 'arrow_back', text: '', url: 'Url' },
    { icon: null, text: <span>Link</span>, url: 'Url' },
  ],
}

export default BreadcrumbsAlt

export interface BreadCrumbsProps {
  icon?: string
  text?: string | JSX.Element
  url?: string
  divider?: JSX.Element
}

function DividerRotateIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M4.667 14.667l6.666-13.334"
      ></path>
    </svg>
  )
}

function DividerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2"
      height="24"
      fill="none"
      viewBox="0 0 2 24"
    >
      <path stroke="#D0D5DD" d="M1 0v24"></path>
    </svg>
  )
}
